import {APIStatus, MobileEasyPayPinStatus} from '@web/core/constants'

import {MobileState} from '../interfaces'

export const getInitialState = (): MobileState => ({
    mobileGeneralPay: {
        phoneNumbers: '',
        billing: {
            pgCp: '',
            pgId: '',
            sid: '',
            minimumAmount: null,
            maximumAmount: null,
        },
    },
    mobileEasyPay: {
        isRegistration: false,
        phoneNumbers: '',
        pinNo: '',
        pinStatus: MobileEasyPayPinStatus.IDLE,
        newPinNo: '',
        confirmPinNo: '',
        apiStatus: APIStatus.IDLE,
        billing: {
            pgCp: '',
            pgId: '',
            sid: '',
            minimumAmount: null,
            maximumAmount: null,
        },
    },
})
